import { reactive } from 'vue'
import { merge as lodash_merge } from 'lodash-es'

class DynamicPageUtils {
  static #theme = reactive({})

  static getTheme() {
    return this.#theme
  }

  static setTheme(theme = {}) {
    Object.keys(this.#theme).forEach(k => delete this.#theme[k])
    Object.assign(this.#theme, theme)
  }

  static mergeTheme(theme = {}) {
    const merged = lodash_merge({}, this.#theme, theme)
    Object.keys(this.#theme).forEach(k => delete this.#theme[k])
    Object.assign(this.#theme, merged)
  }
}

export default DynamicPageUtils
